import React, { FC, useEffect } from 'react';

import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import DoneImg from '~/assets/images/done_v2.webp';
import DonePreviewImg from '~/assets/images/done_v2_preview.png';
import Button from '~/components/atoms/buttons/Button';
import Image from '~/components/atoms/Image';
import {
  DEFAULT_DISCOUNT_VALUE,
  FREE_AMOUNT_OF_DAYS,
  PrepaidBenefits,
} from '~/modules/prepaid/constants';
import analytics from '~/services/analytics';
import { Typographies } from '~/theme/typography';

import styles from './styles.module.scss';

type Props = {
  benefit: PrepaidBenefits;
  onSubmit: () => void;
};

const BenefitsAppliedModal: FC<Props> = ({ benefit, onSubmit }) => {
  const { t } = useTranslation('modal');

  useEffect(() => {
    analytics.trackEvent('prepaid promo - success modal show', {
      promo_type: benefit,
    });
  }, []);

  return (
    <div className={styles.container}>
      <div className={styles.image}>
        <Image src={DoneImg} preview={DonePreviewImg} />
      </div>

      <Typography
        variant={Typographies.TITLE_LARGE}
        component="div"
        className={styles.title}
      >
        {benefit === PrepaidBenefits.EXTRA_WEEK_TRIAL
          ? t('modal:non_prepaid_success.title[0]', {
              amount: FREE_AMOUNT_OF_DAYS,
              defaultValue: '{{amount}} Bonus Days Added!',
            })
          : t('modal:non_prepaid_success.title[2]', {
              percent: DEFAULT_DISCOUNT_VALUE,
              defaultValue: '{{percent}}% Discount Activated!',
            })}
      </Typography>

      <Typography
        variant={Typographies.TITLE_MEDIUM}
        component="div"
        className={styles.text}
      >
        {benefit === PrepaidBenefits.EXTRA_WEEK_TRIAL
          ? t('modal:non_prepaid_success.text[0]', {
              amount: FREE_AMOUNT_OF_DAYS,
              defaultValue:
                'Your trial has been successfully extended by {{amount}} days',
            })
          : t(
              'modal:non_prepaid_success.text[2]',
              'The discount applies for the life of your plan',
            )}
      </Typography>

      <Button
        className={styles.button}
        variant="contained"
        color="primary"
        onClick={onSubmit}
      >
        {t('general:got_it', 'Got it')}
      </Button>
    </div>
  );
};

export default BenefitsAppliedModal;
